<div class="tools-container">
  <div class="page-title">Tools</div>

  <div class="tool-section">
    <h2>Xero Token</h2>

    <div class="token-info-card">
      @if (loadingTokenInfo) {
        <div class="loading-row">
          <mat-spinner diameter="24"></mat-spinner>
          <span>Loading token information...</span>
        </div>
      } @else if (tokenInfoError) {
        <div class="info-grid">
          <span class="info-label">Status</span>
          <span class="info-value"><span class="status-badge expired">No token found</span></span>
        </div>
        <p class="error-detail">{{ tokenInfoError }}</p>
      } @else if (tokenInfo) {
        <div class="info-grid">
          <span class="info-label">Tenant Name</span>
          <span class="info-value">{{ tokenInfo.tenantName }}</span>
          <span class="info-label">Tenant ID</span>
          <span class="info-value mono">{{ tokenInfo.tenantId }}</span>
          <span class="info-label">Token Expires</span>
          <span class="info-value">{{ formatExpiry(tokenInfo.expiryDate) }}</span>
          <span class="info-label">Status</span>
          <span class="info-value">
            <span class="status-badge" [class.valid]="tokenInfo.isValid" [class.expired]="!tokenInfo.isValid">
              {{ tokenInfo.isValid ? 'Valid' : 'Expired' }}
            </span>
          </span>
        </div>
      }
    </div>

    <div class="action-area">
      @if (!isAuthorizing && !authorizationComplete) {
        <button mat-raised-button color="primary" class="validate-button" (click)="validateToken()">
          Validate token
        </button>
      }

      @if (isAuthorizing) {
        <div class="auth-state-row">
          <mat-spinner diameter="22"></mat-spinner>
          <span>Waiting for Xero authorisation — complete the sign-in in the popup window.</span>
        </div>
        <button mat-stroked-button (click)="cancelAuthorization()">Cancel</button>
      }

      @if (authorizationComplete) {
        <div class="auth-state-row success">
          <mat-icon>check_circle</mat-icon>
          <span>Token validated and saved successfully.</span>
        </div>
        <button mat-stroked-button (click)="reset()">Done</button>
      }
    </div>
  </div>
</div>
